export default "__VITE_ASSET__N$S4Ec1K__"